<template>
	<el-drawer title="确认发货" :visible.sync="visible" @close='comStateClose' size="600px" :close-on-press-escape="false"
		id="comDrawer" :modal-append-to-body="false">
		<div class="drawerView">
			<div class="drawerViewT">
				<div class="drawerCom">
					<div class="drawerComL">快递公司：</div>
					<div class="drawerComR">
						<el-select v-model="expressCompanyCode" placeholder="请选择快递公司" style="width: 224px;">
							<el-option v-for="item in logisticsList" :key="item.value" :label="item.title"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">快递单号：</div>
					<div class="drawerComR">
						<el-input v-model="expressNo" placeholder="请输入快递单号" style="width: 224px;"></el-input>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">收货人：</div>
					<div class="drawerComR">
						<span v-if="navData.online_order_data">
							<span v-if="navData.online_order_data.ship_adddress">
								{{navData.online_order_data.ship_adddress.user_name}}
							</span>
						</span>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">联系电话：</div>
					<div class="drawerComR">
						<span v-if="navData.online_order_data">
							<span v-if="navData.online_order_data.ship_adddress">
								{{navData.online_order_data.ship_adddress.phone}}
							</span>
						</span>
					</div>
				</div>
				<div class="drawerCom">
					<div class="drawerComL">收货地址：</div>
					<div class="drawerComR">
						<span v-if="navData.online_order_data">
							<span v-if="navData.online_order_data.ship_adddress">
								{{navData.online_order_data.ship_adddress.address}}
							</span>
						</span>
					</div>
				</div>
			</div>
			<div class="drawerViewB">
				<div class="btn2" @click="comStateClose">取消</div>
				<div class="btn" @click="handleSunmitClick">确定</div>
			</div>
		</div>

	</el-drawer>
</template>

<script>
	export default {
		props: {
			comState: { //显示状态
				default: false
			},
			navData: {
				default () {
					return {}
				}
			},
			navType: {
				default: 0
			}
		},
		watch: {
			// 监视状态发生改变
			comState() {
				this.visible = this.comState;
			},
		},
		data() {
			return {
				visible: true,
				logisticsList:[],
				expressCompanyCode:'',
				expressNo:''
			}
		},
		mounted() {
			console.log(this.navData,this.navType)
			this.getLogisticsList()
		},
		methods: {
			//获取快递公司
			getLogisticsList(){
				this.$http.get(process.env.VUE_APP_AppAdmin + '/api/Logistics/company/list').then((res) => {
					if (res.code == 0) {
						console.log(res.data)
						this.logisticsList = res.data;
					}
				})
			},
			//提交
			handleSunmitClick() {
				if(this.expressCompanyCode == ''){
					this.$message({
						type: 'error',
						message: '请选择快递公司'
					});
					return
				}
				let params = {}
				if(this.navType == 1){
					params = {
						orderNo:this.navData.no,
						goodsInfo:[],
						expressCompanyCode:this.expressCompanyCode,
					    expressNo:this.expressNo
					}
					
					this.navData.order_item_list.map(item=>{
						params.goodsInfo.push({
							goodsId:item.goods_id,
							skuId:item.skus_id,
							unitId:item.packing_way_id,
							unit:item.unit,
							codes:item.code
						})
					})
					console.log(params)
					this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Logistics/goods/Deliver', params).then((res) => {
						if (res.code == 0) {
						console.log(res.data)
						this.$message({
							type: 'success',
							message: '已发货'
						});
						this.$emit("closeOn", {
							type: 'submit'
						});
					}
					})
				}else if(this.navType == 2){
					params = {
						orderNo:this.navData.no,
						expressCompanyCode:this.expressCompanyCode,
					    expressNo:this.expressNo
					}
					this.$http.post(process.env.VUE_APP_AppAdmin + '/api/Logistics/pet/Deliver', params).then((res) => {
						if (res.code == 0) {
						console.log(res.data)
						this.$message({
							type: 'success',
							message: '已发货'
						});
						this.$emit("closeOn", {
							type: 'submit'
						});
					}
					})
				}
				
				
			},
			//向父组件发射关闭弹框
			comStateClose() {
				this.$emit("closeOn", {
					type: 'close'
				});
			},
		},
	}
</script>

<style scoped lang="scss">
	#comDrawer {
		::v-deep .el-drawer__header {
			padding: 20px;
			margin-bottom: 0;
		}

		::v-deep .el-drawer__body {
			height: calc(100% - 65px);
			overflow-y: auto;
		}
	}

	.drawerView {
		height: 100%;
		display: flex;
		flex-direction: column;

		.drawerViewT {
			flex: 1;
			box-sizing: border-box;
			border-top: solid 1px #F2F2F2;
			overflow-y: scroll;

			.drawerCom {
				display: flex;
				margin-top: 32px;
				align-items: center;

				.drawerComL {
					width: 132px;
					margin-right: 22px;
					font-size: 14px;
					color: #343440;
					text-align: right;
					line-height: 20px;
				}

				.drawerComR {
					flex: 1;
					font-size: 14px;

					.drawerSelect {
						display: flex;
						flex: 1;
						flex-wrap: wrap;

						.drawerSelectItem {
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #69697B;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							margin-bottom: 10px;

							div:nth-of-type(1) {
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 16px;
								height: 16px;
								border-radius: 100%;
								border: solid 1px #B0B0BF;
							}
						}

						.drawerSelectActiveItem {
							width: 128px;
							height: 44px;
							box-sizing: border-box;
							font-size: 14px;
							color: #577BFF;
							text-align: center;
							line-height: 44px;
							position: relative;
							background: #FAFAFD;
							border-radius: 8px;
							margin-right: 16px;
							margin-bottom: 10px;
							border: 1px solid #577BFF;

							div:nth-of-type(1) {
								position: absolute;
								left: 16px;
								top: 0;
								bottom: 0;
								margin: auto 0;
								width: 4px;
								height: 4px;
								border-radius: 100%;
								border: solid 6px #577BFF;
							}
						}

					}
				}
			}
		}

		.drawerViewT::-webkit-scrollbar {
			display: none;
		}

		.drawerViewB {
			height: 60px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding: 0 20px;
			border-top: solid 1px #F2F2F2;
			box-sizing: border-box;

			.btn {
				width: 98px;
				line-height: 40px;
				text-align: center;
				background: linear-gradient(135deg, #5685FF 0%, #3569FF 100%);
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				color: #fff;
				cursor: pointer;
				margin-left: 20px;
			}

			.btn2 {
				width: 98px;
				line-height: 40px;
				text-align: center;
				border-radius: 10px;
				font-size: 16px;
				font-weight: bold;
				cursor: pointer;
				box-sizing: border-box;
				border: solid 1px #577BFF;
				color: #577BFF;
			}
		}
	}
</style>
